<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M12 21s-7-7.5-7-12a7 7 0 0 1 14 0c0 4.5-7 12-7 12Z" />
    <circle
      cx="12"
      cy="9"
      r="2.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconMapMarker',
  props: {
    size: { type: [String, Number], default: 13 },
    strokeWidth: { type: [String, Number], default: 2.2 },
  },
};
</script>
